import { render, staticRenderFns } from "./DataDescSection.vue?vue&type=template&id=39e5465f&"
import script from "./DataDescSection.vue?vue&type=script&lang=js&"
export * from "./DataDescSection.vue?vue&type=script&lang=js&"
import style0 from "./DataDescSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports